import { render } from "./CRMSiteFormDatatableActions.vue?vue&type=template&id=6a86b765&scoped=true"
import script from "./CRMSiteFormDatatableActions.vue?vue&type=script&lang=js"
export * from "./CRMSiteFormDatatableActions.vue?vue&type=script&lang=js"

import "./CRMSiteFormDatatableActions.vue?vue&type=style&index=0&id=6a86b765&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a86b765"]])

export default __exports__